<template>
  <div class="pcFooter">
    <div class="w1200 clear">
      <div class="cont clear border_b">
        <div class="ewm ewm_tt" v-if="active == 1">
          <img src="@/assets/lib/images/ewm_tt.png" alt />
          <p>扫描二维码</p>
        </div>
        <div class="ewm ewm_wx" v-if="active == 2">
          <img src="@/assets/lib/images/ewm_wx.png" alt />
          <p>扫描二维码</p>
        </div>
        <div class="imgs">
          <img :src="active == 1 ? require('@/assets/pc/images/icon_tt1.png') : require('@/assets/pc/images/icon_tt.png')" alt @mouseenter="active = 1" @mouseleave="active = 0" />
          <img :src="active == 2 ? require('@/assets/pc/images/icon_wx1.png') : require('@/assets/pc/images/icon_wx.png')" alt @mouseenter="active = 2" @mouseleave="active = 0" />
        </div>
        <ul class="clear">
          <li class="w480">
            <p>联系电话：13671004684（同微信号）</p>
            <p>联系人：冯兴臣 邮箱：fengxingchen@nxin.com</p>
            <p>公司地址：江苏省盐城市亭湖区希望大道 6 号未来科技城西区 27 号楼</p>
          </li>
          <li class="w300">
            <p>加入我们投递简历</p>
            <p>邮箱：wangke@nxin.com</p>
          </li>
          <li>
            <el-link class="color_b" href="https://www.nxinsz.com/" target="_blank" :underline="false">公司介绍</el-link>
            <!-- <p class="cursor">公司介绍</p> -->
          </li>
        </ul>
      </div>
      <div class="copyright">
        © 2013-2026 农信数智版权所有 苏 ICP 备 2024123296 号 苏公网安备 32099102000253 号 联系地址：江苏省盐城市亭湖区希望大道 6 号未来科技城西区 27 号楼
        <!-- Copyright © 2013-2021 农信互联版权所有 <span @click="activeClick('https://beian.miit.gov.cn')">京ICP备13013445号</span>
        京公网安备11010802000105 -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      active: 0,
    };
  },
  methods: {
    activeClick(url) {
      window.location.href = url;
    },
  },
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
